module.exports = __webpack_public_path__ + "img/docker-compose.6d8fe586.png";